module.exports = __webpack_public_path__ + "img/homepage-banner-image.7cf5b5e5.jpg";